import { groupLifeService } from '@/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useQuoteParams } from '../../context/quote-params.context';

export type GroupLifeCalculateQuoteResult = Record<string, unknown> & {
  sentToUnderwritingAnalysis?: boolean;
  underwritingMessages?: unknown[];
};

export function useCalculateGroupLifeQuote() {
  const { policyId } = useQuoteParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['group-life', 'quote', policyId, 'calculate'],
    retry: false,
    mutationFn: async (): Promise<GroupLifeCalculateQuoteResult> => {
      if (!policyId) throw new Error('policyId é obrigatório');
      const result = await groupLifeService.calculateQuote(policyId);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Erro ao calcular a cotação');
      }
      return result.data as GroupLifeCalculateQuoteResult;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['group-life', 'quote-details', policyId],
        }),
        queryClient.invalidateQueries({
          queryKey: ['group-life', 'members-page', policyId],
        }),
        queryClient.invalidateQueries({
          queryKey: ['group-life', 'proposal-lives', policyId],
        }),
        queryClient.invalidateQueries({
          queryKey: ['pme-tarifacao', 'quote', policyId],
        }),
      ]);
    },
  });
}
